<template>
    <label class="block max-w-4xl relative">
        <div style="display: flex; justify-content: space-between">
            <span class="text-gray-700 dark:text-gray-200">{{ label }}</span>
        </div>

        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span class="text-gray-500 sm:text-sm">
                <slot name="prepend"></slot>
            </span>
        </div>

        <input
            :class="[
                $slots.prepend ? 'pl-6' : null,
                error ? 'border-red-600' : 'border-gray-300'
            ]"
            class="block w-full rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1 disabled:opacity-50"
            :name="name"
            type="color"
            @input="(e) => {
                return $emit('input', e.target.value)
            }"
            @blur="() => {
                return $emit('blur')
            }"
            :value="value"
            :disabled="disabled"
            ref="inputText"
        />

        <slot></slot>

        <error class="mt-1" :error="error" />
    </label>
</template>

<script>
export default {
    name: "InputColour",
    props: {
        name: String,
        label: String,
        value: [String],
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
        }
    },

};
</script>
